import styled from "styled-components";

export const VideoSlidesFilterItemPreviewDefaultBox = styled.div<{filterCount: number}>`
    width: 100%;
    flex: 1 1 calc((100% - (${props => props.filterCount} - 1) * 8px) / ${props => props.filterCount});
    position: relative;
`;

